$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$(document).ready(function () {

    /** Mobile navigation*/

    (function () {
        var menu = $('.menu'),
            user_menu = $('.user-menu');
// responsive nav open class
        $('.rm-button').on('click', function () {
            menu.toggleClass('open');
            user_menu.removeClass('open');
            menu.removeClass('open-search');

        });
        $('.search-btn').on('click', function (e) {
            e.stopPropagation();
            menu.toggleClass('open-search');
            user_menu.removeClass('open');

        });

        $('.header-user .user-avatar').on('click', function (e) {
            e.stopPropagation();
            user_menu.toggleClass('open');
            menu.removeClass('open-search');

        });

        $('.user-notification').on('click', function (e) {
            e.stopPropagation();
            $('.user-wishlist').removeClass('open');
            $('.user-menu-link').removeClass('open');
            $('.user-wishlist').find('.dd-menu-holder').removeClass('open');
            $('.user-points').removeClass('open');
            $('.user-points').find('.dd-menu-holder').removeClass('open');
            $(this).toggleClass('open');
            $(this).find('.dd-menu-holder').toggleClass('open');
        });

        $('.user-wishlist').on('click', function (e) {
            e.stopPropagation();
            $('.user-notification').removeClass('open');
            $('.user-menu-link').removeClass('open');
            $('.user-notification').find('.dd-menu-holder').removeClass('open');
            $('.user-points').removeClass('open');
            $('.user-points').find('.dd-menu-holder').removeClass('open');
            $(this).toggleClass('open');
            $(this).find('.dd-menu-holder').toggleClass('open');
        });


        $('.user-menu-link').on('click', function (e) {
            e.stopPropagation();
            $('.user-notification').removeClass('open');
            $('.user-notification').find('.dd-menu-holder').removeClass('open');
            $('.user-wishlist').removeClass('open');
            $('.user-wishlist').find('.dd-menu-holder').removeClass('open');
            $('.user-points').removeClass('open');
            $('.user-points').find('.dd-menu-holder').removeClass('open');
            $(this).toggleClass('open');
        });

        $('.user-points').on('click', function (e) {
            e.stopPropagation();
            $('.user-notification').removeClass('open');
            $('.user-notification').find('.dd-menu-holder').removeClass('open');
            $('.user-wishlist').removeClass('open');
            $('.user-wishlist').find('.dd-menu-holder').removeClass('open');
            $('.user-menu-link').removeClass('open');
            $(this).toggleClass('open');
        });

        $(window).on('click',function (e) {
            $('.user-notification').removeClass('open');
            $('.user-notification').find('.dd-menu-holder').removeClass('open');
            $('.user-wishlist').removeClass('open');
            $('.user-wishlist').find('.dd-menu-holder').removeClass('open');
            $('.user-menu-link').removeClass('open');
            $('.user-points').removeClass('open');
        });

        $('.responsive-category-menu').addClass('close');
        $('.toggle-aside').on('click', function (e) {
            e.stopPropagation();
            $('.responsive-category-menu').toggleClass('open');
            $('.responsive-category-menu').toggleClass('close');

        });

// $('.successs .unsuccess').on('click', function () {
//     $(this).removeClass('unsuccess').removeClass('success');
// })

        $('input[name=search]').on('click', function (e) {
            e.stopPropagation();
        }).keyup(function (e) {
            if (e.keyCode == 27) {
                menu.removeClass('open-search');
            }   // escape key maps to keycode `27`
        });
        menu.on('click', function () {
            menu.removeClass('open');
        });
    })();

    /** add class on click responsive user and main nav*/
    (function () {
        var el = $('.main-header .menu nav');
        $('.main-header .user-avatar').click(function () {
            el.toggleClass('user-close');
            el.toggleClass('user-open');

        });
        $('.rm-button').click(function () {
            el.addClass('user-close');
            el.removeClass('user-open');
            $('body').toggleClass('overflow-y');

        });
    }());

    /** Custom input file browse button*/
    $(".btn-browse").click(function () {
        $(this).siblings(".browse").trigger('click');
    });

    $("input[type='file'].browse").change(function () {
        $(this).siblings('.fake-path').text(this.value.replace(/C:\\fakepath\\/i, ''))
    });

    /** Class for input:focus border*/
    $(".input-group > input").focus(function (e) {
        $(this).parent().addClass("input-group-focus");
    }).blur(function (e) {
        $(this).parent().removeClass("input-group-focus");
    });

    /** Header shrink*/
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $(".main-header").addClass("header-shrink");
        } else {
            $(".main-header").removeClass("header-shrink");
        }
    });


// Course badge children counter
// Stari uslov za proveru badgeva, novi je preko php-a
//     $.each($('.badges'), function () {
//         if ($(this).children().length === 1) {
//             $(this).addClass('single-badge');
//         } else {
//             $(this).addClass('multi-badge')
//         }
//     });

// remove popup on click
    $(".close-button").click(function () {
        $(this).parents(".close-element").slideUp(200, function () {
            $(this).remove();
        });
    });
// remove on background click
    $('.popup-bgd').click(function () {
        $('.popup-box').slideUp(200, function () {
            $(this).remove();
        });
        $(this).removeClass('popup-bgd');
    });
    $('.popup-box').click(function (e) {
        e.stopPropagation();
    });

// ALERTS
    $('div.alert-hide').delay(4000).slideUp(300);

// PROMOCODE CHECK
    $("#promocode").keyup(function () {
        var input = $(this),
            btn = $("#checkId");

        if (input.val() != '') {
            btn.attr('disabled', false);
        } else {
            btn.attr('disabled', true);
        }
    });

    $("#checkId").on('click', function () {

        var text_holder = $("#promocodeText");
        var loading = Ladda.create(this);

        text_holder.attr('class', '').html('');
        loading.start();

        var input = $("#promocode");
        var code = input.val();
        if (code == '') {
            alert('Promo kôd nije ispravan');
            loading.stop();
            return;
        }

        $.get('/promocode/provera/' + code + '/' + $('[name=pc_lm]').val() + '/' + $('[name=pc_c]').val(),
            {},
            function (response) {

// Promocode text
                text_holder.html(response.message);

// Prices
                if (response.valid === true) {
                    $(".coursePrice").html(response.new_price_formatted);
                    $(".installments-load").html(response.new_installments);
                    text_holder.removeClass('promo-message-bad').addClass('promo-message-ok');
                } else {
                    text_holder.removeClass('promo-message-ok').addClass('promo-message-bad');
                }

                loading.stop();
            })
    });

});

// User Activity scripts
function set_user_activity(activity, value) {
    $.post({
        url: '/korisnik/akcija/set',
        data: {
            activity: activity,
            value: value
        }
    });
}

function remove_user_activity(activity) {
    $.post({
        url: '/korisnik/akcija/remove',
        data: {
            activity: activity
        }
    });
}

function social_bundle() {
    var options = {
        excludeUserAgent: true,
        excludeOpenDatabase: true,
        excludeJsFonts: true,
        excludeCpuClass: true,
        excludeDoNotTrack: true,
        excludeCanvas: true,
        excludeWebGL: true,
        excludeHasLiedOs: true,
        excludePlugins: true,
        excludeTouchSupport: true,
        excludeScreenResolution: true,
        excludeAvailableScreenResolution: true
    };
    new Fingerprint2(options).get(function (result, all) {
        $('form').submit(function () {
            $(this).append('<input type="hidden" name="fp_id" value="' + result + '" /> ');
            return true;
        });

// If he logs-in via facebook
        $('#facebook-login').on('click', function () {
            var date = new Date();
            date.setTime(date.getTime() + (60 * 1000));
            var expires = "; expires=" + date.toGMTString();

            document.cookie = "fp_id=" + result + expires + "; path=/";
        });
    });

}


if ($('.popup-box').length != 0) {
    $('.user-course-page, #classroom.classroom, #user-panel.training').addClass('popup-bgd');
}
$(".close-button").click(function () {
    $('.user-course-page, #classroom.classroom, #user-panel.training').removeClass("popup-bgd");
});



/*DODATI AJAX METODU SLANJA NA DONTSHOWUP (INACE SVE RADI SAMO AJAX DODATI)*/
var slug = $("#course-slug").val();
$('#dontShowPopUp').on('click', function () {
    $.ajax({
        url: '/ne-prikazuj',
        type: 'post',
        data: {
            slug: slug
        }
    })
        .done(function (result) {
            $('.user-course-page, #classroom.classroom').removeClass("popup-bgd");
            $(".close-element").hide();
        })
        .fail(function (err) {
            console.log(err);
        });
});



// Ispod 991px menja href user a taga u headeru
$(document).ready(function(){
    if ($(window).width() < 975) {
        $(".user-avatar-holder").attr("href", "javascript:void(0)")
    }
});
